import React, { useEffect, useState } from 'react';
import * as billService from '../store/services/billServices';
import PricingTable from './PricingTable';
import Loading from 'react-loading';

function SubscribePage() {
  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    billService.getSubscriptionSession()
      .then((res) => {
        setClientSecret(res.data.client_secret);
      })
      .catch(() => {
        setError('Unable to load subscription options. Please try again.');
      });
  }, []);

  if (error) {
    return (
      <div className='page'>
        <div style={{ textAlign: 'center', padding: 60 }}>{error}</div>
      </div>
    );
  }

  if (!clientSecret) {
    return (
      <div className='page'>
        <div className='loading'>
          <Loading type='spinningBubbles' color='#171717' />
        </div>
      </div>
    );
  }

  return <PricingTable client_secret={clientSecret} />;
}

export default SubscribePage;
